import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        employeeDepartmentBudget: '<'
    },
    template: `
        <h3>{{ 'reports.Employee budgets' | translate }}</h3>
        <table class="data01 mt1em">
            <thead>
            <tr>
                <th>{{ 'reports.Employee' | translate }}</th>
                <th>{{ 'reports.Budget' | translate }}</th>
                <th>{{ 'reports.Planned' | translate }}</th>
                <th>{{ 'reports.Spent' | translate }}</th>
                <th>{{ 'reports.Total' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr ng-repeat="employeeDepartmentBudget in vm.employeeDepartmentBudgets">
                    <td>{{ employeeDepartmentBudget.user.displayName }}</td>
                    <td>{{ employeeDepartmentBudget.budgetSum }} €</td>
                    <td>{{ employeeDepartmentBudget.budgetReserved ? employeeDepartmentBudget.budgetReserved : 0 }} €</td>
                    <td>{{ employeeDepartmentBudget.budgetUsed ? employeeDepartmentBudget.budgetUsed : 0 }} €</td>
                    <td>{{ employeeDepartmentBudget.budgetSum }} €</td>
                    <td class="actions">
                        <a ng-click="vm.openEmployeeExpenses(employeeDepartmentBudget)" class="btn view">{{ 'reports.View expenses' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor ($scope, ModalService) {
        this.parentScope = $scope.$parent;
        this.ModalService = ModalService;
    }

    $onInit () {
        const { parentScope } = this;
        this.employeeDepartmentBudgets = parentScope.vm.list.items[parentScope.index].employeeDepartmentBudgets;
        this.filter = parentScope.vm.filter;
    }

    openEmployeeExpenses (employeeDepartmentBudget) {
        const { filter } = this;
        return this.ModalService.open({
            template: '<modals-user-employee-expenses filter="vm.filter" employee-department-budget="vm.employeeDepartmentBudget" cancel="vm.$uibModalInstance.close()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.employeeDepartmentBudget = employeeDepartmentBudget;
                this.filter = filter;
            },
            size: 'large'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/budget/employee/index.js